export default {
  'ec.footer.window': '«Единое окно» для международной торговли в торговой зоне',
  'ec.footer.policy': 'Государственные услуги провинции Хэйлунцзян',
  'ec.footer.depart': 'Создание предприятий в Харбине через поезда',
  'ec.footer.tax':'Налоговое управление провинции Хэйлунцзян Харбин',
  'ec.footer.custom':'Харбинская таможня Китайской Народной Республики',
  'ec.footer.depart.serve':'Харбинская корпоративная сервисная платформа',
  'ec.footer.bank':'Банк Харбина',
  'ec.footer.law':'Юридическая фирма Heilongjiang Meng Fanxu',
  'ec.footer.province.app':'Приложение "Провинциальные дела"',
  'ec.footer.province.ali':'Мини-программа Alipay "Провинциальные дела"',
  'ec.footer.province.tencent':'Мини-программа WeChat «Провинциальные дела»',
  'ec.footer.website.relate':'Связанные сайты',
  'ec.footer.country.policy':'Национальная платформа государственных услуг',
  'ec.footer.country':'Сайт Центрального народного правительства Китайской Народной Республики',
  'ec.footer.province':'Веб-сайт народного правительства провинции Хэйлунцзян',
  'ec.footer.website.info':'Информация о веб-сайте',
  'ec.footer.website.contact':'Свяжитесь с нами',
  'ec.footer.website.state':'Выписка по сайту',
  'ec.footer.website.about':'О нас',
  'ec.footer.website.report':'Неверная подача информации',
  'ec.footer.website.map':'Карта сайта',
}